import { AD_MIN_INTERVAL_MS, AD_CLOSE_DELAY_MS } from '@shared/constants.js';

/**
 * AdManager — UX-first advertising strategy
 * 
 * Rules:
 * 1. NEVER interrupt audio
 * 2. NEVER show ads on first session open
 * 3. Show interstitial ONLY when user returns to the app (Page Visibility API)
 * 4. Minimum 5 min between ads
 * 5. Close button appears after 3 seconds
 * 6. All ads are visual only (images/video muted) — no audio ads EVER
 */
export class AdManager {
  constructor() {
    this.lastAdShown = 0;
    this.isFirstSession = true;
    this.adCount = 0;
    this.adsenseReady = typeof window.adsbygoogle !== 'undefined';

    // DOM refs
    this.interstitialEl = document.getElementById('ad-interstitial');
    this.closeBtn = document.getElementById('ad-close');
    this.adSlot = document.getElementById('ad-interstitial-slot');

    if (this.interstitialEl) {
      this._setupVisibilityListener();
      this._setupCloseButton();
    }
  }

  /**
   * Listen for when user returns to the app
   */
  _setupVisibilityListener() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this._onUserReturns();
      }
    });
  }

  /**
   * Called when user returns to the tab/app
   */
  _onUserReturns() {
    // RULE 1: Never on first session
    if (this.isFirstSession) {
      this.isFirstSession = false;
      return;
    }

    // RULE 2: Respect minimum interval
    const now = Date.now();
    if (now - this.lastAdShown < AD_MIN_INTERVAL_MS) {
      return;
    }

    // RULE 3: Show visual interstitial
    this._showInterstitial();
  }

  /**
   * Show the interstitial overlay (visual only, audio continues underneath)
   */
  _showInterstitial() {
    // Injeção de anúncios manuais em modais/popups viola as políticas do Google AdSense.
    // O Google gerencia anúncios de tela cheia (Vignettes) automaticamente pelo script do head.
    return;
  }

  /**
   * Placeholder ad (dev/pre-approval)
   */
  _showPlaceholder() {
    this.adSlot.innerHTML = `
      <div style="
        width: 300px; height: 250px;
        background: linear-gradient(135deg, #181830, #10101e);
        border: 1px solid rgba(244, 197, 66, 0.2);
        border-radius: 12px;
        display: flex; align-items: center; justify-content: center;
        color: #5a5a78; font-size: 14px; text-align: center;
        font-family: 'Outfit', sans-serif;
      ">
        <div>
          <div style="font-size: 32px; margin-bottom: 8px;">📻</div>
          <div>Amen Atlas</div>
          <div style="font-size: 11px; margin-top: 4px; color: #3a3a58;">Espaço publicitário</div>
        </div>
      </div>
    `;
  }

  /**
   * Close the interstitial
   */
  _setupCloseButton() {
    this.closeBtn.addEventListener('click', () => {
      this.interstitialEl.classList.add('hidden');
    });

    // Also close on backdrop click
    this.interstitialEl.addEventListener('click', (e) => {
      if (e.target === this.interstitialEl) {
        // Only if close button is visible
        if (!this.closeBtn.classList.contains('hidden')) {
          this.interstitialEl.classList.add('hidden');
        }
      }
    });
  }
}
